// removed by extract-text-webpack-plugin
module.exports = {"noResults":"ai_aj","container":"ai_g","recommendEvent":"ai_ak"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventList/EventListContainer.module.css
// module id = 1219
// module chunks = 27